import { createSelector } from '@ngrx/store';
import { AppState } from '../../app-state/app-state';
import { UserState } from './user.state';

export const getUserState = (state: AppState) => state.user;

export const getUserData = createSelector(getUserState, (state: UserState) => state.user);

export const getLoadedUser = createSelector(getUserState, (state: UserState) => state.loaded);

export const getCurrentUpdatedUser = createSelector(getUserState, (state: UserState) => state.currentUpdatedUser);
